import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = { class: "footer-links" }
const _hoisted_3 = ["href"]
const _hoisted_4 = {
  key: 0,
  class: "mobile-nav-space"
}
const _hoisted_5 = {
  key: 0,
  class: "mobile-nav-space"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_img = _resolveComponent("ion-img")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_footer = _resolveComponent("ion-footer")!

  return (_openBlock(), _createBlock(_component_ion_footer, {
    collapse: "fade",
    id: "footer"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_grid, { id: "footer-content" }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_row, { class: "ion-justify-content-start ion-align-items-center ion-padding-bottom ion-padding-top" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.topLinks, (link) => {
                return (_openBlock(), _createBlock(_component_ion_col, {
                  size: "12",
                  "size-md": "6",
                  "size-lg": "auto",
                  key: link.name,
                  class: _normalizeClass([{ 'ion-text-center': !_ctx.isMobile }, "top-links"])
                }, {
                  default: _withCtx(() => [
                    (link.to)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          to: { path: link.to, query: { utm_medium: 'web', utm_source: 'footer' } },
                          class: "color-white no-underline large footer-nav-link",
                          "data-link": "footer"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(link.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                      : (link.href)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            href: link.href,
                            target: "_blank",
                            class: "color-white no-underline large footer-nav-link"
                          }, _toDisplayString(link.name), 9, _hoisted_1))
                        : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["class"]))
              }), 128))
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_ion_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_col, {
                  size: "12",
                  "size-md": "5",
                  class: "pl-0"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_col, {
                          size: "12",
                          class: "px-0 ion-text-uppercase"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, { color: "medium" }, {
                              default: _withCtx(() => _cache[0] || (_cache[0] = [
                                _createElementVNode("b", null, " About ", -1)
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.aboutLinks, (link) => {
                          return (_openBlock(), _createBlock(_component_ion_col, {
                            size: "6",
                            "size-md": "5",
                            key: link.name,
                            class: "pl-0 pr-0"
                          }, {
                            default: _withCtx(() => [
                              (link.to.includes('http'))
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    href: link.to,
                                    target: "_blank",
                                    class: "color-white no-underline large"
                                  }, _toDisplayString(link.name), 9, _hoisted_3))
                                : (_openBlock(), _createBlock(_component_router_link, {
                                    key: 1,
                                    to: { path: link.to, query: { utm_medium: 'web', utm_source: 'footer' } },
                                    class: "color-white no-underline large",
                                    "data-link": "footer"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(link.name), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"]))
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_col, {
                  size: "12",
                  "size-md": "3",
                  "offset-md": "1",
                  class: "px-0 sub-columns"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_row, { class: "full-height" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_col, {
                          size: "12",
                          class: "px-0"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, {
                              color: "medium",
                              class: "ion-text-uppercase"
                            }, {
                              default: _withCtx(() => _cache[1] || (_cache[1] = [
                                _createElementVNode("b", null, " Connect With Us", -1)
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.socialLinks, (link) => {
                          return (_openBlock(), _createBlock(_component_ion_col, {
                            size: "3",
                            key: link.name,
                            class: "pa-0"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_button, {
                                href: link.href,
                                target: "_blank",
                                fill: "clear",
                                class: "social-btn px-0"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    slot: "icon-only",
                                    "aria-label": 'link to ' + link.name,
                                    alt: link.name,
                                    icon: link.logo,
                                    class: "full-height full-width"
                                  }, null, 8, ["aria-label", "alt", "icon"])
                                ]),
                                _: 2
                              }, 1032, ["href"])
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (!_ctx.isNative)
                  ? (_openBlock(), _createBlock(_component_ion_col, {
                      key: 0,
                      "size-md": "3",
                      class: "ion-align-items-center px-0 sub-columns"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_row, { class: "full-height" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_col, {
                              size: "12",
                              class: "px-0"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, {
                                  color: "medium",
                                  class: "ion-text-uppercase"
                                }, {
                                  default: _withCtx(() => _cache[2] || (_cache[2] = [
                                    _createElementVNode("b", null, " Download our app ", -1)
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_col, {
                              size: "6",
                              class: "pa-0 full-height download-col"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_button, {
                                  href: "https://apps.apple.com/us/app/donatos/id599722601",
                                  target: "_blank",
                                  fill: "clear",
                                  class: "pl-0 my-0 full-height download-btn"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_img, {
                                      alt: "Apple Store Logo",
                                      slot: "start",
                                      src: require('@/assets/apple-store.svg'),
                                      class: "full-height ma-0"
                                    }, null, 8, ["src"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_col, {
                              size: "6",
                              class: "pa-0 full-height download-col"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_button, {
                                  fill: "clear",
                                  href: "https://play.google.com/store/apps/details?id=com.donatos.phoenix",
                                  target: "_blank",
                                  class: "pr-0 my-0 full-height download-btn"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_img, {
                                      alt: "GooglePlay Logo",
                                      src: require('@/assets/google-play.svg'),
                                      class: "full-height ma-0"
                                    }, null, 8, ["src"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_ion_row, { class: "ion-justify-content-between ion-align-items-center mt-button" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_col, {
                  size: "12",
                  class: "ion-padding-start pa-0 small color-medium"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, {
                      to: "/copyright",
                      "data-link": "footer",
                      class: "legal-link no-underline hover-underline"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" © " + _toDisplayString(new Date().getFullYear()) + " Donatos Pizzeria, LLC.", 1)
                      ]),
                      _: 1
                    }),
                    _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
                    _createVNode(_component_router_link, {
                      to: "/termsandconditions",
                      "data-link": "footer",
                      class: "legal-link no-underline hover-underline"
                    }, {
                      default: _withCtx(() => _cache[3] || (_cache[3] = [
                        _createTextVNode(" Terms & Conditions ")
                      ])),
                      _: 1
                    }),
                    _cache[6] || (_cache[6] = _createElementVNode("span", { class: "small" }, "  |  ", -1)),
                    _createVNode(_component_router_link, {
                      to: "/privacy-policy",
                      "data-link": "footer",
                      class: "legal-link no-underline hover-underline"
                    }, {
                      default: _withCtx(() => _cache[4] || (_cache[4] = [
                        _createTextVNode(" Privacy Policy ")
                      ])),
                      _: 1
                    }),
                    _cache[7] || (_cache[7] = _createElementVNode("span", { class: "small" }, "  |  ", -1)),
                    _cache[8] || (_cache[8] = _createElementVNode("a", {
                      href: "https://forms.office.com/Pages/ResponsePage.aspx?id=YLMnacd2zUuOKRIbATdm80DINotpy6FMsJ9yNYe3oltUMEtGTFlYWDMzQUVWTzFVMVgxR0NLTDFHNi4u",
                      class: "legal-link no-underline hover-underline"
                    }, " Do not sell or share my data ", -1))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ion_row, null, {
              default: _withCtx(() => _cache[9] || (_cache[9] = [
                _createElementVNode("p", { class: "legal-link" }, "2,000 calories per day is used for general nutrition advice, but calorie needs may vary. Additional nutrition information is available upon request.", -1)
              ])),
              _: 1
            }),
            (_ctx.isNative)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }),
      (_ctx.isNative)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}